export default __webpack_public_path__ + "static/media/3s.b32205a0.svg";